/**
 * vaultState utils
 * Lightweight helpers to apply canonical resolver state to UI models.
 */
'use strict';

const normalizeVaultState = (vaultState) => {
  const raw =
    typeof vaultState === 'string'
      ? vaultState
      : vaultState?.vaultState || vaultState?.data?.vaultState || null;
  return String(raw || '').trim().toUpperCase();
};

export const mapVaultStateToStatus = (vaultState) => {
  const state = normalizeVaultState(vaultState);
  if (!state) return null;
  if (state === 'READY') return 'ready';
  if (state === 'INIT') return 'created';
  if (state === 'INGESTING' || state === 'PARTIAL_READY') return 'processing';
  if (state === 'BLOCKED_LOW_QUALITY') return 'failed';
  if (state === 'ERROR') return 'failed';
  return null;
};

export const applyVaultStateToNotebook = (notebook, vaultState) => {
  if (!notebook || !vaultState) return notebook;
  const status = mapVaultStateToStatus(vaultState);
  const resolvedState = normalizeVaultState(vaultState);

  const patch = {
    _vaultState: vaultState,
    vaultState: resolvedState || notebook?.vaultState || null,
  };
  if (vaultState?.vaultEpoch) {
    patch.vaultEpoch = vaultState.vaultEpoch;
  }

  if (status) {
    patch.status = status;
    patch.isReady = status === 'ready';
    patch.isProcessing = status === 'processing';
    patch.isError = status === 'failed';
  }

  return { ...notebook, ...patch };
};
